import { Link } from "react-router-dom";
import type { Match } from "@/types";
import { teamMap } from "@/mocks/teams";
import TeamLogo from "@/components/base/TeamLogo";
import { formatTime, formatDateLabel, weekdayLabel } from "@/utils/format";

interface SchedulePreviewProps {
  matches: Match[];
}

export default function SchedulePreview({ matches }: SchedulePreviewProps) {
  if (matches.length === 0) {
    return (
      <div className="rounded-lg border border-background-200 bg-background-100 p-8 text-center text-sm text-foreground-500">
        近几日暂无赛事安排
      </div>
    );
  }

  return (
    <div className="flex flex-col divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
      {matches.map((match) => {
        const home = teamMap[match.homeTeamId];
        const away = teamMap[match.awayTeamId];
        if (!home || !away) return null;
        return (
          <Link
            key={match.id}
            to={`/match/${match.id}`}
            className="flex items-center gap-3 px-4 py-3 transition-colors hover:bg-background-100"
          >
            <div className="w-14 shrink-0 text-center">
              <p className="font-heading text-base font-bold text-primary-600">{formatTime(match.startTime)}</p>
              <p className="text-[11px] text-foreground-500">{weekdayLabel(match.startTime)}</p>
            </div>
            <div className="flex flex-1 items-center justify-center gap-2 min-w-0">
              <span className="truncate text-sm font-medium text-foreground-800 text-right flex-1">{home.name}</span>
              <TeamLogo team={home} size="sm" />
              <span className="text-xs text-foreground-400">vs</span>
              <TeamLogo team={away} size="sm" />
              <span className="truncate text-sm font-medium text-foreground-800 flex-1">{away.name}</span>
            </div>
            <span className="hidden shrink-0 text-xs text-foreground-500 sm:block">{formatDateLabel(match.startTime)}</span>
          </Link>
        );
      })}
    </div>
  );
}